export const version = '2.15.1';
//# sourceMappingURL=version.js.map